function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.8136 13.4193L16.2865 24.9461L15.0659 23.7254L26.5819 12.1883C26.6846 12.0852 26.8044 12.07 26.8668 12.07C26.9289 12.07 27.0487 12.0852 27.1516 12.1881L27.8136 12.85C27.9705 13.007 27.9705 13.2624 27.8136 13.4193ZM13.4829 25.3568L14.6558 26.5297L12.7178 27.2884L13.4829 25.3568ZM28.9944 11.6697L28.3322 11.0077C27.9409 10.616 27.4206 10.4004 26.867 10.4004H26.8666C26.3125 10.4006 25.7918 10.6166 25.4003 11.0087L12.2094 24.2237C12.1289 24.3041 12.0661 24.4003 12.0241 24.5061L10.4589 28.4582C10.3366 28.7672 10.409 29.1193 10.6436 29.3545C10.8032 29.515 11.0172 29.6004 11.2353 29.6004C11.3375 29.6004 11.4406 29.5816 11.5395 29.5428L15.5043 27.9905C15.6116 27.9486 15.7088 27.8847 15.7902 27.8036L28.9942 14.6C29.8021 13.7925 29.8023 12.478 28.9944 11.6697Z",
  fill: "#1F2F53"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 19.2,
  fill: "white",
  transform: "translate(10.4 10.3999)"
})));

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit.92e42db8.svg";
export { ForwardRef as ReactComponent };